module.exports = __webpack_public_path__ + "img/11.4b079f30.jpg";